import React from 'react';
import { Col, FormGroup, Label, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';

const TestDetails = (props) => (
  <Col className="d-flex flex-column">
    <FormGroup>
      <Label>Date & Time of Test</Label>
      <DatePicker 
        dateFormat="MMMM d, yyyy h:mm aa"
        selected={props.date}
        onChange={date => props.setFieldValue("date", date)}
        maxDate={new Date()}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
      />
      {props.errors.date && props.touched.date && <div id="feedback" className="text-danger">{props.errors.date}</div>}
    </FormGroup>
    <FormGroup>
      <Label>Lab Name</Label>
      <Input type="text"
        name="lab"
        value={props.lab}
        onChange={props.handleChange}
      />
      {props.errors.lab && props.touched.lab && <div id="feedback" className="text-danger">{props.errors.lab}</div>}
    </FormGroup>
  </Col>
)

export default TestDetails;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/TestDetails.js